/*/
 * Animated scroll
/*/
	const siteScroll = _ => {
		const scrollElements = document.querySelectorAll('[site-reveal]')
		const scrollObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is--revealed')
				} else {
					entry.target.classList.remove('is--revealed')
				}
			})
		}, {
			threshold: 0,
			rootMargin: '25px 25px 25px 25px'
		})

		scrollElements.forEach(target => scrollObserver.observe(target))
	}


window.addEventListener('load', function () {
	setTimeout(() => {
		siteScroll()
	}, 500)
})
